/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TimelineHistory from '../../../../../components/ui-elements/timeline/TimelineHistory';
import { Typography } from '@mui/material';
import { useState } from 'react';
import { getAccountMappingHistory } from '../../../../../store/reducers/mapping/mappingAction';

const MappingHistory = ({ selectedMapping }) => {
    const [historyList, setHistoryList] = useState([]);
    const dispatch = useDispatch()
    const mappingHistory = useSelector(state => state.mapping.mappingsHistory)
    useEffect(() => {
        dispatch(getAccountMappingHistory({ "applicationMappingID": selectedMapping.applicationMappingID }));
    }, [dispatch, selectedMapping]);
    useEffect(() => {
        setHistoryList([]);
        console.log('mappingHistory', mappingHistory)
        if (mappingHistory?.length > 0) {
            mappingHistory.forEach(element => {
                setHistoryList(item => [...item, {
                    ...element, Record: {
                        name: " Application : " + element.Record.applicationName + " - Identity Provider : " + element.Record.authProviderName + " -  GetChkd ID : " + element.Record.getChkdID,
                        details: element.Record.details ?? [],
                        createdBy: element.Record.createdBy ?? "",
                        updatedBy: element.Record.updatedBy ?? "",
                    }
                }])
            });
        }
    }, [mappingHistory]);

    return (
        <>
            <Typography variant="h3" align="center" color="success.light">Mapping  History</Typography>
            <TimelineHistory items={historyList} />
        </>
    )

}


export default MappingHistory;